var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpreadsheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H42C45.3137 0 48 2.68629 48 6V42C48 45.3137 45.3137 48 42 48H6C2.68629 48 0 45.3137 0 42V6Z",
    fill: "#9FD1CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15V13C18 11.8954 17.1046 11 16 11H10C8.89543 11 8 11.8954 8 13V15C8 16.1046 8.89543 17 10 17H16C17.1046 17 18 16.1046 18 15Z",
    fill: "#DAF4F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25V23C18 21.8954 17.1046 21 16 21H10C8.89543 21 8 21.8954 8 23V25C8 26.1046 8.89543 27 10 27H16C17.1046 27 18 26.1046 18 25Z",
    fill: "#DAF4F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 35V33C18 31.8954 17.1046 31 16 31H10C8.89543 31 8 31.8954 8 33V35C8 36.1046 8.89543 37 10 37H16C17.1046 37 18 36.1046 18 35Z",
    fill: "#DAF4F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15V13C40 11.8954 39.1046 11 38 11H24C22.8954 11 22 11.8954 22 13V15C22 16.1046 22.8954 17 24 17H38C39.1046 17 40 16.1046 40 15Z",
    fill: "#DAF4F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25V23C40 21.8954 39.1046 21 38 21H24C22.8954 21 22 21.8954 22 23V25C22 26.1046 22.8954 27 24 27H38C39.1046 27 40 26.1046 40 25Z",
    fill: "#DAF4F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 35V33C40 31.8954 39.1046 31 38 31H24C22.8954 31 22 31.8954 22 33V35C22 36.1046 22.8954 37 24 37H38C39.1046 37 40 36.1046 40 35Z",
    fill: "#DAF4F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheet);
export default __webpack_public_path__ + "static/media/spreadsheet.4577e44a.svg";
export { ForwardRef as ReactComponent };